var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledCacheWrapper } from '../../../../styles';
import StyledFormGridColumn from './form-grid-column.styles';
var propTypes = {
  /** FormGrid.Column Content */
  children: PropTypes.node,
  /** Size of the column.<br /><br />
   * **sm** -  min-width : 0px <br />
   * **md** - min-width : 768px <br />
   * **lg** - min-width : 1024px <br />
   * **xl** - min-width : 1200px
   */
  col: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  /** Sets the offset position of a column. */
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
};
var defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment, null),
  col: 12,
  offset: 0
};
var FormGridColumn = function FormGridColumn(_ref) {
  var children = _ref.children,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledFormGridColumn, other, children));
};
FormGridColumn.propTypes = propTypes;
FormGridColumn.defaultProps = defaultProps;
FormGridColumn.displayName = 'FormGrid.Column';
export default FormGridColumn;